import { render, staticRenderFns } from "./LbaBreadcrumb.vue?vue&type=template&id=4a591c5d"
import script from "./LbaBreadcrumb.vue?vue&type=script&lang=js"
export * from "./LbaBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./LbaBreadcrumb.vue?vue&type=style&index=0&id=4a591c5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports